import React from 'react';
import { Layout } from '../components/Layout';
import { Card } from '../components/ui/Card';
import { useTranslation } from '../i18n';
export function PatientPrivacyNoticePage() {
  const {
    t
  } = useTranslation();
  return <Layout data-id="element-2404">
      <section className="bg-teal-900 text-white py-16" data-id="element-2405">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-2406">
          <h1 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-2407">
            Patient Privacy Notice
          </h1>
          <p className="text-teal-100" data-id="element-2408">Last updated: 5 February 2026</p>
        </div>
      </section>

      <section className="py-16 bg-gray-50" data-id="element-2409">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2410">
          <Card className="p-8 md:p-12 prose prose-teal max-w-none" data-id="element-2411">
            <p className="lead" data-id="element-2412">
              Dentico Dental Clinic Ltd is responsible for your personal data.
            </p>

            <h3 data-id="element-2413">
              When you request an appointment or become our patient, we may
              collect:
            </h3>
            <ul data-id="element-2414">
              <li data-id="element-2415">contact details,</li>
              <li data-id="element-2416">appointment and administrative details,</li>
              <li data-id="element-2417">
                relevant health information needed to provide safe dental care.
              </li>
            </ul>

            <h3 data-id="element-2418">We use your data to:</h3>
            <ul data-id="element-2419">
              <li data-id="element-2420">provide dental care and manage appointments,</li>
              <li data-id="element-2421">communicate about treatment and follow-up,</li>
              <li data-id="element-2422">
                comply with legal, regulatory, and professional obligations.
              </li>
            </ul>

            <h3 data-id="element-2423">Data Sharing</h3>
            <p data-id="element-2424">
              We do not sell your data. We may share data with trusted providers
              (e.g. booking/IT systems, laboratories, advisers) where necessary
              and lawful.
            </p>

            <h3 data-id="element-2425">Your Rights</h3>
            <p data-id="element-2426">
              You have data protection rights under UK law, including access,
              correction, objection/restriction, and withdrawal of consent where
              consent is used.
            </p>

            <div className="bg-teal-50 p-6 rounded-xl mt-8 not-prose" data-id="element-2427">
              <h3 className="text-lg font-bold text-teal-900 mb-4" data-id="element-2428">
                Contact Us
              </h3>
              <div className="space-y-2 text-teal-800" data-id="element-2429">
                <p data-id="element-2430">
                  <strong data-id="element-2431">Email:</strong>{' '}
                  <a href="mailto:info@denticoclinic.co.uk" className="hover:underline" data-id="element-2432">
                    info@denticoclinic.co.uk
                  </a>
                </p>
                <p data-id="element-2433">
                  <strong data-id="element-2434">Address:</strong> 360–364 City Road, London EC1V 2PY
                </p>
                <p data-id="element-2435">
                  <strong data-id="element-2436">Phone:</strong> +44 7345 197820
                </p>
              </div>
            </div>
          </Card>
        </div>
      </section>
    </Layout>;
}